import { createFileRoute } from '@tanstack/react-router'

import { RenewalHistoryPage } from '@/features/membership/renewal'

export const Route = createFileRoute('/_authenticated/membership/renewals')({
  component: RenewalHistoryPage,
})

